import { render, staticRenderFns } from "./BtnImportarDirf.vue?vue&type=template&id=06f88856&"
import script from "./BtnImportarDirf.vue?vue&type=script&lang=js&"
export * from "./BtnImportarDirf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports